// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__LRN7O"};